import { Component, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Equipment } from '../../context-discovery-services/models/equipment.model';

@Component({
  selector: 'adminapp-equipment-type-selector',
  templateUrl: './equipment-type-selector.component.html',
  styleUrls: ['./equipment-type-selector.component.scss']
})
export class EquipmentTypeSelectorComponent implements AfterViewInit {

  equipmentTypeSelectorDomRepeat: any;
  equipmentTypeSelector: any;

  @Input()
  set equipmentTypesList(listOfEquipments: Array<Equipment>) {
    if (!this.equipmentTypeSelector) {
      return;
    }
    this.equipmentTypeSelectorDomRepeat.items = listOfEquipments.map(equip => {
      equip['total'] =
        equip.confirmedAssetCount + equip.unconfirmedAssetCount;
      return equip;
    });
    // setTimeout(() => {
    //   if (!this.equipmentTypeSelector.value) {
    //     this.equipmentTypeSelector.value = listOfEquipments[0].iri;
    //   }
    // }, 0);
  }

  @Output()
  equipmentSelected: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngAfterViewInit() {
    this.equipmentTypeSelector = document.getElementById('equipmentTypeSelector');
    this.equipmentTypeSelectorDomRepeat = document.querySelector('#equipmentTypeSelector dom-repeat');
    if (this.equipmentTypeSelector) {
      this.equipmentTypeSelector.addEventListener('value-changed', this.onEquipmentSelected.bind(this));
    }
  }

  setSelectedValue(selectedEquipmentIri: string) {
    setTimeout(() => {
      setTimeout(() => {
        if (this.equipmentTypeSelector) {
          this.equipmentTypeSelector.value = null;
          if (selectedEquipmentIri) {
            this.equipmentTypeSelector.value = selectedEquipmentIri;
          } else {
            this.equipmentTypeSelector.value = this.equipmentTypeSelectorDomRepeat.items[0].iri;
          }
          this.equipmentTypeSelector._finishSelect();
        }
      }, 10);

    }, 0);
  }

  onEquipmentSelected(event: any) {
    this.equipmentSelected.emit(event.detail.value);
  }

  getSelectedValue() {
    if (this.equipmentTypeSelector) {
      return this.equipmentTypeSelector.value;
    }
  }
}
